import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { instance2} from '../../utils/axiosInstance'
import { useNavigate } from 'react-router-dom'
import { EyeIcon } from '@heroicons/react/16/solid';
import { formatNumber } from "../../numberingformat"; // Ensure formatNumber works for formatting



export default function DaftarStockDapur() {
    const navigate = useNavigate()
    const locationId = localStorage?.getItem("locationId")
    const kitchenId = localStorage?.getItem("kitchenId")
  const roleId = parseInt(localStorage.getItem('roleId'),10); 

  const localDateString = (thedate) =>{

    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');
    
  console.log("startDate", thedate);
  const localDateString = `${year}-${month}-${day}`;
  
  return localDateString
  
  }

  const [formData, setFormData] = useState({
    order_no: "",
    order_id: "",
    supplier_id: "",
    supplier_name: "",
    admin_id: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [location, setLocation] = useState([]); // Storage locations
  const [loading, setLoading] = useState(true); // Loading state
  const [user, setUser] = useState("");
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRowData, setEditRowData] = useState(null);
  const [isDropdownModalOpen, setIsDropdownModalOpen] = useState(false);
  const [modalSearchTerm, setModalSearchTerm] = useState(""); // Modal-specific search term
  const [modalFilteredLocations, setModalFilteredLocations] = useState([]); // Modal-specific filtered locations
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
  

  useEffect(() => {
    setModalFilteredLocations(
      location.filter((loc) =>
        loc.name.toLowerCase().includes(modalSearchTerm.toLowerCase())
      )
    );
  }, [modalSearchTerm, location]);
  
  const dropdownRef = useRef(null); // Ref to track dropdown

  const filteredLocations = location.filter((loc) =>
    loc.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    const storedUser = localStorage.getItem('userAuthentication');
    if (storedUser) {
      setUser(storedUser);
    }
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: user //parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage("");
  
    try {
      const response = await instance2.post("kitchen", formData);
  
      setSuccessMessage("Kitchen created successfully!");
      setFormData({
        name: "",
        location_id: "",
        description: "",
        admin_id: user, // Reset admin_id to current user
      });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create Kitchen. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await instance2.get("location"); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setLocation(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.location_name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch locations", err);
        setError(err.response?.data?.message || "Failed to fetch storage locations");
      } finally {
        setLoading(false);
      }
    };
  
    fetchLocation();
  }, []);
  

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  useEffect(() => {
    let response
  const fetchData = async () => {
    try {
      (response = await instance2.get(`/ingredients_stock/kitchen/location/${locationId}`))
       // Use instance2 for the API call
      setData(response.data); // Set data from the Axios response
     // console.log(`/delivery_order/location/${locationId}`, response.data)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();
}, [roleId, locationId]);

const getWeekStartAndEndDates = (date) => {
  const current = new Date(date);
  const dayOfWeek = current.getDay();
  const monday = new Date(current);
  monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  return { startDate: localDateString(monday), endDate: localDateString(sunday)};
};

const { startDate, endDate } = getWeekStartAndEndDates(new Date());

const handlePenerimaan = async () => {
  navigate(`/penerimaanbahan?startDate=${startDate}&endDate=${endDate}`);
};

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setEditRowData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (startDate, endDate) => {
    navigate(`/penerimaanPO?startDate=${startDate}&endDate=${endDate}`);
    // setEditRowData({
    //   id: row.id, // Ensure `id` is passed
    //   kitchen_name: row.kitchen_name,
    //   description: row.description,
    //   kitchen_pack: row.kitchen_pack,
    //   location_id: row.location_id,
    // });
  
    // const selectedLocation = location.find((loc) => loc.id === row.location_id);
    // setModalSearchTerm(selectedLocation ? selectedLocation.name : "");
  
    // setIsModalOpen(true);
  };

  const handleEyeClick = (startDate, endDate) => {
    navigate(`/daftarpemesanan?startDate=${ startDate}&endDate=${endDate}`);
  };
  
  
const handleUpdate = async () => {
  const payload = {
    name: editRowData.kitchen_name,
    location_id: editRowData.location_id,
    description: editRowData.description,
    kitchen_pack: editRowData.kitchen_pack,
    admin_id: localStorage.getItem("userAuthentication") || ""
  };

  try {
    const response = await instance2.put(`kitchen/${editRowData.id}`, payload);

    if (response.status === "OK") {
      alert('Data updated successfully!');
      setIsModalOpen(false); // Close modal on success
      // Optionally refresh table data
    }
  } catch (error) {
    console.error('Error updating data:', error);
    alert('Failed to update data. Please try again.');
  }
};
  
useEffect(() => {
  const fetchLocation = async () => {
    try {
      const response = await instance2.get("location"); // Use instance2 for the API call

      const locationData = response.data; // Access the data property from Axios response

      setLocation(
        locationData.map((loc) => ({
          id: loc.id,
          name: loc.location_name,
          code: loc.code,
        }))
      );
    } catch (err) {
      console.error("Failed to fetch locations", err);
      setError(err.response?.data?.message || "Failed to fetch storage locations");
    } finally {
      setLoading(false);
    }
  };

  fetchLocation();
}, []);


  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this data? This action cannot be undone."
    );
  
    if (!confirmDelete) {
      return; // Exit if the user cancels the deletion
    }
  
    try {
      const response = await instance2.delete(`kitchen/${id}`); // Replace `kitchen` with your endpoint
  
      if (response.status === "OK") {
        alert("Data deleted successfully!");
        // Remove the deleted row from the table
        setData((prevData) => prevData.filter((item) => item.id !== id));
      } else {
        alert("Failed to delete data. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("An error occurred while deleting the data.");
    }
  };
  

// Filter data based on search query
const filteredData = data.filter((item) => {
  const formattedDate = new Date(item.delivery_date).toLocaleDateString("id-ID", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  return (
    (item.ingredient_name?.toLowerCase() || "").includes(searchQuery) ||
    (item.stock?.toLowerCase() || "").includes(searchQuery)||
    (item.kitchen_name?.toLowerCase() || "").includes(searchQuery)
    // String(item.id).includes(searchQuery) // Match ID as string
  );
  
});

     const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
       const itemsPerPage = 10; // Number of items per page
         // Pagination logic
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         const paginatedData = filteredData.slice(
           (currentPage - 1) * itemsPerPage,
           currentPage * itemsPerPage
         );
       
         const handlePreviousPage = () => {
           if (currentPage > 1) setCurrentPage(currentPage - 1);
         };
       
         const handleNextPage = () => {
           if (currentPage < totalPages) setCurrentPage(currentPage + 1);
         };
       
         // Determine which page numbers to show
         let pageNumbers = [];
         const maxVisiblePages = 5;
       
         if (totalPages <= maxVisiblePages) {
           pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
         } else {
           if (currentPage <= 3) {
             // Near the beginning
             pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
           } else if (currentPage >= totalPages - 2) {
             // Near the end
             pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
           } else {
             // In the middle
             pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
           }
         }

  return (
    
            
    <div className="p-4">
      
<div className="flex flex-row items-center justify-between mb-3">
        <h2 className="block text-black text-xl sm:text-2xl my-1 font-medium">Daftar Stok Bahan Baku di Dapur</h2>
      </div>
{data.length === 0 ? (
  <div className="flex w-full items-center justify-center text-center py-6 text-gray-500">
    Tidak ada data yang tersedia
  </div>
) : (
  <>
    {/* Search Bar */}
                <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
                
                <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
                  <MagnificationLogo />
                  <VerticalLine className="mx-1" />
                  <input
                    type="text"
                    placeholder="Telusuri data berdasarkan dapur atau nama bahan baku"
                    className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
                    style={{
                      width: `${"Telusuri data berdasarkan dapur atau nama bahan baku".length}ch`,
                    }}
                    value={searchQuery} // Controlled input
                    onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                  />
                </div>
                {roleId === 2  || roleId === 4 || roleId === 5 ? (
<div className="w-full px-3 py-4 text-center">
  {/* <button
    type="button"
     onClick={handlePenerimaan}
    className=
    // {deliveryOrderExist === 0 ? 
      "w-full px-8 py-4 text-white rounded-[50px] mx-4 bg-merah-no hover:bg-merah-hover uppercase" 
      // :
      // "w-full px-8 py-4 text-white rounded-[50px] mx-4 bg-gray-200 uppercase"}
      // disabled = {deliveryOrderExist != 0}
  >
     BUAT DO
  </button> */}
  </div>
) : ("")}
                </div>
      <table className="table-fixed w-full border-collapse text-left">
        <thead>
          <tr className="bg-white">
            <th
              className="w-[50px] border-b border-gray-300 px-4 py-2 cursor-pointer rounded-tl-[15px]"
              onClick={() => handleSort('kitchen_name')}
            >
              No.{' '}
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('kitchen_name')}
            >
              Dapur{' '}
              <span className="float-right">{getSortArrow('date')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('kitchen_name')}
            >
              Bahan Baku{' '}
              <span className="float-right">{getSortArrow('date')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 text-right rounded-tr-[15px]" 
            >
              Stok{' '}
              <span className="float-right">{getSortArrow('order_no')}</span>
            </th>
            {/* <th
              className="border-b border-gray-300 px-4 py-2 text-right rounded-tr-[15px]" 
            >
            </th> */}
            {/* <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('order_no')}
            >
              Periode{' '}
              <span className="float-right">{getSortArrow('supplier_name')}</span>
            </th> */}
            {/* <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-center rounded-tr-[15px]"
            >
              Aksi
            </th> */}
          </tr>

        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
            key={item.id}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
      <td className="w-[50px] px-4 py-2 text-left">
      {index + 1 + (currentPage - 1) * itemsPerPage}</td>
      <td className="border-gray-300 px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.kitchen_name}</td>
      <td className="border-gray-300 px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.ingredient_name}</td>
      <td className="border-gray-300 px-4 py-2 text-xxs md:text-xxs lg:text-base text-right">{formatNumber(item.stock)}</td>
      {/* <td className="w-[50px] px-4 py-2 text-left"></td> */}
      {/* <td className="border-gray-300 px-4 py-2">{localDateString(new Date(item.startdate))} - {localDateString(new Date(item.enddate))}</td> */}
        {/* <td className="border-gray-300 px-4 py-2 text-center">
        
        <div className="flex justify-center items-center gap-2">
          <button
            className="text-gray-500 p-2 rounded hover:bg-blue-400"
            onClick={() => handleEyeClick(localDateString(new Date(item.startdate)), localDateString(new Date(item.enddate)))}
          >
            <EyeIcon className="w-5 h-5" />
          </button>
          <button
            className="text-gray-500 p-2 rounded hover:bg-blue-400"
            onClick={() => handleEditClick(localDateString(new Date(item.startdate)), localDateString(new Date(item.enddate)))}
          >
            <EditIcon className="w-5 h-5" />
          </button>
          <button
            className="text-gray-500 p-2 rounded hover:bg-red-400"
            onClick={() => handleDelete(item.id)}
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        </div>
      </td> */}
    </tr>
  ))}
</tbody>
      </table>  
      
      
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
  </>
)}

{/* Edit Modal */}
      {isModalOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
        <div className="bg-white p-4 rounded-lg w-1/3">
          <h2 className="text-lg font-bold mb-4">Ubah Data Dapur</h2>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Nama Dapur</label>
            <input
              type="text"
              name="kitchen_name"
              value={editRowData.kitchen_name || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          <div className="mb-4 relative" ref={dropdownRef}>
            <label className="block text-gray-700 mb-2">Koperasi</label>
            <input
              type="text"
              placeholder="Pilih koperasi"
              value={modalSearchTerm}
              onChange={(e) => setModalSearchTerm(e.target.value)}
              onFocus={() => setIsDropdownModalOpen(true)}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
            />
            {isDropdownModalOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {modalFilteredLocations.length > 0 ? (
                  modalFilteredLocations.map((loc) => (
                    <div
                      key={loc.id}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setEditRowData({ ...editRowData, location_id: loc.id });
                        setModalSearchTerm(loc.name);
                        setIsDropdownModalOpen(false);
                      }}
                    >
                      {loc.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    No locations found
                  </div>
                )}
              </div>
            )}
          </div>
          
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Jumlah Siswa</label>
            <input
              type="text"
              name="kitchen_pack"
              value={editRowData.kitchen_pack || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Deskripsi</label>
            <textarea
              name="description"
              value={editRowData.description || ""}
              onChange={handleModalChange}
              className="w-full px-3 py-2 border rounded-md bg-gray-100"
            ></textarea>
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={() => setIsModalOpen(false)}
            >
              Batal
            </button>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={handleUpdate}
            >
              Simpan
            </button>
          </div>
        </div>
      </div>
    )}

  </div>
  );
}
